export default __webpack_public_path__ + "static/pic5-89f5d48d377334b441ff08986c7da874.jpg";